import { render, staticRenderFns } from "./EditAddLocationItemDialog.vue?vue&type=template&id=588e4b06"
import script from "./EditAddLocationItemDialog.vue?vue&type=script&lang=js"
export * from "./EditAddLocationItemDialog.vue?vue&type=script&lang=js"
import style0 from "./EditAddLocationItemDialog.vue?vue&type=style&index=0&id=588e4b06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports